import templateUrl from 'emun.vendor/vendor-app-connection.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import ServiceBus from 'servicestack/service-bus'
import modals from 'webmodals/modals'
import ShopifyCredentials from "emun.vendor/vendor-shopify-credentials"

class VendorAppConnectionController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		    $ctrl.bus = new ServiceBus();
        if ($ctrl.$session.isRetailer && !$ctrl.vendorId) $ctrl.vendorId = $ctrl.$session.retailerId;
        $ctrl.getSecret();
        $ctrl.load();
    }
    getSecret() {
        const $ctrl = this;
        $ctrl.bus.send("AWS/GetSecret", {
          SecretName: "SFTP/" + $ctrl.vendorId
        }).then(function(response) {
          if (response.data.secretString) {
            $ctrl.secretData = JSON.parse(response.data.secretString);
            $ctrl.load();
          }
        });
      }
    load() {
        const $ctrl = this;
        $ctrl.appConnections = [
            {
                app: "NetSuite",
                enabled: false,
                companyId: ""
            },
            {
                app: "QuickBooks Online",
                enabled: false,
                companyId: ""
            },
            {
                app: "Shopify",
                enabled: false,
                companyId: ""
            },
            {
                app: "Stripe",
                enabled: false,
                companyId: ""
            },
        ];
        $ctrl.bus
        .send("QueryVendors.json?Active=1&Id=" + $ctrl.vendorId)
        .then(function(res) {
          if (res.data.results.length > 0) {
            $ctrl.vendor = res.data.results[0];
            if ($ctrl.secretData.QuickbooksCompanyId) {
                $ctrl.appConnections.filter(a => a.app == "QuickBooks Online")[0].enabled = true;
                $ctrl.appConnections.filter(a => a.app == "QuickBooks Online")[0].companyId = $ctrl.secretData.QuickbooksCompanyId;
            }
            if ($ctrl.secretData.NetSuiteAccountId && $ctrl.secretData.NetSuiteTokenSecret) {
                $ctrl.appConnections.filter(a => a.app == "NetSuite")[0].enabled = true;
                $ctrl.appConnections.filter(a => a.app == "NetSuite")[0].companyId = $ctrl.secretData.NetSuiteAccountId;
            }
            if ($ctrl.secretData.ShopifyCompanyId) {
                $ctrl.appConnections.filter(a => a.app == "Shopify")[0].enabled = true;
                $ctrl.appConnections.filter(a => a.app == "Shopify")[0].companyId = $ctrl.secretData.ShopifyCompanyId;
            }
            if ($ctrl.secretData.StripeAccountId) {
                $ctrl.appConnections.filter(a => a.app == "Stripe")[0].enabled = true;
                $ctrl.appConnections.filter(a => a.app == "Stripe")[0].companyId = $ctrl.secretData.StripeAccountId;
            }


            // if ($ctrl.vendor.settings.filter( s=> s.key == "QuickbooksCompanyId").length) {
            //     $ctrl.appConnections.filter(a => a.app == "QuickBooks Online")[0].enabled = true;
            //     $ctrl.appConnections.filter(a => a.app == "QuickBooks Online")[0].companyId = $ctrl.vendor.settings.filter( s=> s.key == "QuickbooksCompanyId")[0].value;
            // }
            // if ($ctrl.vendor.settings.filter( s=> s.key == "ShopifyCompanyId").length) {
            //     $ctrl.appConnections.filter(a => a.app == "Shopify")[0].enabled = true;
            //     $ctrl.appConnections.filter(a => a.app == "Shopify")[0].companyId = $ctrl.vendor.settings.filter( s=> s.key == "ShopifyCompanyId")[0].value;
            // }
            // if ($ctrl.vendor.settings.filter( s=> s.key == "StripeAccountId").length) {
            //     $ctrl.appConnections.filter(a => a.app == "Stripe")[0].enabled = true;
            //     $ctrl.appConnections.filter(a => a.app == "Stripe")[0].companyId = $ctrl.vendor.settings.filter( s=> s.key == "StripeAccountId")[0].value;
            // }
          }
        });
    }
    connect(app) {
        const $ctrl = this;
        if (app.app == "QuickBooks Online") $ctrl.connectQuickbooks();
        if (app.app == "NetSuite") $ctrl.connectNetSuite();
        if (app.app == "Shopify") $ctrl.connectShopify();
        if (app.app == "Stripe") $ctrl.connectStripe();
    }
    connectQuickbooks() {
        const $ctrl = this;
        $ctrl.bus.send("Quickbooks/GetOAuthUrl.json?VendorId=" + $ctrl.vendorId).then(function(res) {
            console.debug("BL*** res", res);
            if (res.data.url) {
                window.location.href = res.data.url;
            }
        })
    }
    connectNetSuite() {
        const $ctrl = this;
        // $ctrl.bus.send("NetSuite/GetOAuthUrl.json?VendorId=" + $ctrl.vendorId).then(function(res) {
        //     console.debug("BL*** res", res);
        //     if (res.data.url) {
        //         window.location.href = res.data.url;
        //     }
        // })
    }
    connectShopify() {
        const $ctrl = this;
        ShopifyCredentials({vendorId: $ctrl.vendorId}).then(res => $ctrl.load());
    }
    connectStripe() {
        const $ctrl = this;
        $ctrl.bus.send(`Stripe/GenerateOAuthLink?VendorId=${$ctrl.vendorId}`).then(function(res) {
            if (res.data.url) {
                window.location.href = res.data.url;
            }
        });
    }
}

export default {
	bindings: {
        vendorId: '@'
	},
    controller: VendorAppConnectionController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};